import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { DateFnsModule } from 'ngx-date-fns';

import { GetPipe } from '@lockton-apps/shared/util/ng-lodash';
import { ToLocalTimePipe } from '@lockton-apps/shared/util/ngx-date-fns-tz';

import { DynamicTableColumnTemplate } from '../column-template.directive';

export enum DynamicTableDateFormat {
  DEFAULT,
  SHORT,
  LONG,
  TO_NOW,
}

interface DateProps {
  path: string;
  format?: string;
}

@Component({
    selector: 'la-dynamic-table-template-initials',
    imports: [
        CommonModule,
        DateFnsModule,
        GetPipe,
        ToLocalTimePipe,
        LetDirective,
    ],
    templateUrl: './date.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynamicTableTemplateDateComponent extends DynamicTableColumnTemplate<DateProps> {
  formats = DynamicTableDateFormat;
}
